export function formatUnionTagPresentCheck(check) {
  return `record tag ${check.tag} must be present`;
}
